import {
  Accordion,
  AccordionSummary,
  Divider,
  List,
  ListItemButton,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { LogoutConfirmDialog } from "./logInComponents/LogoutConfirmDIalog";
import { useEffect, useState } from "react";
import { DownloadDetailComponent } from "./settingsComponents/DownloadDetailComponent";
import { ReminderDetailComponent } from "./settingsComponents/ReminderDetailComponent";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

export const SettingsMenu = () => {
  const navigate = useNavigate();
  const { idToken, refreshAuthSession } = useAuth();
  const [logoutConfirmDialogIsOn, setLogoutConfirmDIalogIsOn] =
    useState<boolean>(false);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  useEffect(() => {
    if (idToken) {
      try {
        const decodedToken: any = jwtDecode(idToken);
        const userGroups = decodedToken["cognito:groups"] || [];
        setIsAdmin(userGroups.includes("Admin"));
      } catch (error) {
        console.error("Token decode error:", error);
      }
    }
  }, [idToken]);

  return (
    <>
      <Paper
        elevation={10}
        sx={{ m: 3, backgroundColor: "white", borderRadius: 4 }}
      >
        <List>
          {/* 通常リンク */}
          <Accordion sx={{ boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>リマインダ設定</Typography>
            </AccordionSummary>
            <ReminderDetailComponent />
          </Accordion>

          {/* アコーディオン */}
          <Accordion sx={{ boxShadow: "none" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>ダウンロード方法の確認</Typography>
            </AccordionSummary>
            <DownloadDetailComponent />
          </Accordion>
          <Divider />

          {/* 別のリンク */}
          <ListItemButton onClick={() => window.open("/manual.pdf", "_blank")}>
            <Typography>マニュアル</Typography>
          </ListItemButton>
          {/* <Divider />
          <ListItemButton>
            <Typography>利用規約(作成中)</Typography>
          </ListItemButton> */}
          <Divider />
          <ListItemButton
            onClick={() => window.open("/third-party-licenses.txt", "_blank")}
          >
            <Typography>著作権とライセンス</Typography>
          </ListItemButton>
          <Divider />
          <ListItemButton onClick={() => navigate("/contact")}>
            <Typography>お問い合わせ</Typography>
          </ListItemButton>
          <Divider />
          {isAdmin && (
            <>
              <ListItemButton onClick={() => navigate("/admin")}>
                <Typography>管理者ページ</Typography>
              </ListItemButton>
              <Divider />
            </>
          )}
          <ListItemButton onClick={() => setLogoutConfirmDIalogIsOn(true)}>
            <Typography>ログアウト</Typography>
          </ListItemButton>
        </List>
      </Paper>
      <LogoutConfirmDialog
        isOn={logoutConfirmDialogIsOn}
        setIsOn={setLogoutConfirmDIalogIsOn}
      />
    </>
  );
};
